import React, { Component } from 'react';
import {
  connect,
  ConnectedProps
} from 'react-redux';
import {
  get,
} from 'lodash';
import {
  ELSCommonUIConstants,
  ELSPendoService,
  ELSTokenHelper,
} from '@els/els-ui-common-react';
import {
  ELSAnalyticsRegistrarComponent,
  ELSPerformanceAnalyticsRegistrarProps
} from '@els/els-component-shared-ts-react';
import { cwSelectors } from '../../redux/courseware/courseware.selectors';
import { AppConstants } from '../app/app.constants';
import {
  convertIsbnsToNormalizedString,
  getApplicationContext
} from '../../utilities/app.utilities';
import {
  getIsChatBotLinkVisible,
  hasDataForChatBotLink,
  isInstructor,
  isStudent
} from '../../utilities/common.utilities';

const mapStateToProps = state => ({
  course: cwSelectors.getCourse(state),
  courseSectionId: cwSelectors.getCourseSectionId(state),
  isbns: cwSelectors.getIsbns(state),
  userId: cwSelectors.getUserId(state),
  userRole: cwSelectors.getRoleId(state),
  evolveUser: cwSelectors.getEvolveUser(state),
  evolveProducts: cwSelectors.getEvolveProducts(state),
  featureFlagsGrouped: cwSelectors.getFeatureFlagsGrouped(state),
  courseSettingsFlags: cwSelectors.getCourseSettingsFlags(state),
  isSaiEnabledForCourse: cwSelectors.getSaiEligibilityForCourse(state, cwSelectors.getCourseSectionId(state)),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export type AnalyticsRegistrarState = {
  pendoScriptInjected: boolean;
}

export type AnalyticsRegistrarProps = PropsFromRedux;

export class AnalyticsRegistrar extends Component<AnalyticsRegistrarProps, AnalyticsRegistrarState> {

  constructor(props) {
    super(props);
    this.state = {
      pendoScriptInjected: !!window.pendo && !!window.pendo.initialize,
    };
  }

  componentDidMount() {
    if (!this.state.pendoScriptInjected) {
      ELSPendoService.injectScript(AppConstants.PENDO_API_KEY).then(() => {
        this.setState({ pendoScriptInjected: true });
      });
    }
  }

  getEvolveUserEmail = () => {
    const { evolveUser } = this.props;
    if (!evolveUser) {
      return null;
    }
    const evolveUserData = JSON.parse(evolveUser.userData);
    if (!evolveUserData?.email) {
      return null;
    }
    return evolveUserData.email;
  }

  render() {
    const {
      isbns,
      userRole,
      course,
      userId,
      evolveProducts,
      evolveUser,
      featureFlagsGrouped,
      courseSettingsFlags,
      isSaiEnabledForCourse,
      courseSectionId
    } = this.props;

    if (!isbns || !course || !evolveProducts || !this.state.pendoScriptInjected) {
      return <></>;
    }

    if (!evolveUser) {
      return <></>;
    }

    const institution = course ? course.institution : null;
    const courseName = course ? course.courseName : null;

    let saiDetails = 'sai:unknown';

    const saiKnown = hasDataForChatBotLink({
      featureFlagsGrouped,
      courseSettingsFlags,
      courseSectionId,
      course,
      isSaiEnabledForCourse
    });

    if (saiKnown) {
      saiDetails = getIsChatBotLinkVisible(
        featureFlagsGrouped,
        courseSettingsFlags,
        courseSectionId,
        course,
        isSaiEnabledForCourse
      ) ? 'sai:true' : 'sai:false';
    }

    const props: ELSPerformanceAnalyticsRegistrarProps = {
      isbn: convertIsbnsToNormalizedString(isbns),
      userRole,
      appName: ELSCommonUIConstants.appIds.SHER_EVOL,
      productName: get(window, 'pageData.page.productName', ''),
      businessUnit: get(window, 'pageData.page.businessUnit', ''),
      visitorId: null,
      pageEnvironment: get(window, 'pageData.page.environment', ''),
      courseId: course.id.toString(),
      accountName: institution ? institution.name : null,
      accountId: institution ? institution.id.toString() : null,
      evolveUserId: evolveUser ? evolveUser.userName.toString() : null,
      eolsUserId: userId,
      shouldInjectPendoScript: false,
      eolsUserEmail: ELSTokenHelper.getUserEmail(),
      evolveUserEmail: this.getEvolveUserEmail(),
      isStudent: isStudent(userRole),
      isInstructor: isInstructor(userRole),
      isIncludeAdobeEducationObject: true,
      courseName,
      departmentId: '',
      departmentName: '',
      application: getApplicationContext(evolveProducts),
      adobeVisitorProps: {
        details: saiDetails
      }
    };

    return <ELSAnalyticsRegistrarComponent {...props} />;
  }
}

export default connector(AnalyticsRegistrar);
